// extracted by mini-css-extract-plugin
module.exports = {"card":"accordion-module--card--1Kl_t","title":"accordion-module--title--1BYit"};